import { Theme, createStyles } from '@material-ui/core';
const styles = (theme: Theme) => createStyles({
datePickerUi:{  
    '&>:first-child':{
        '&>:first-child':{
            border: "1px solid #e0e0e0",
            borderRadius:4,
            height:36,
            lineHeight:'36px',
            padding: "0 5px",
        },
        
        '& input':{
            border: 'none',
            background: 'transparent',
            height: '32px',
            '&:focus':{
                border: 'none'
            },
            '&:active':{
                border: 'none'
            }
        }
    },    
  },
  mt10:{
    marginTop: 10,
    marginLeft: 15,
    },
    addEditMilestone:{
        border: "1px solid #e1e1e1",
        background: "#fff",
        padding: "10px 10px 5px 10px",
        margin: "10px 15px 10px 0",
    }
});


export { styles}